let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3B5nW")).then(() => parcelRequire('fj5k5'));